import {useHistory, useRouteMatch} from "react-router-dom";
import {hashHistory} from "react-router"; // omg pls don't kill me for that

import {setWizardActiveItem, setWizardActiveStep, setWizardSelectedValues} from "../../../actions/wizardFunctions";
import store from "../../../store";
import {
  getAvailableSteps,
  getCurrentGroups,
  getDefaultMaterialsWizardItem, getWizardGroupFromCurrentSteps
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import Misc from "../../../misc/misc";
import {ROUTES} from "../../../routes";
import {IS_LIXIL_UI} from "../../../config";

const getSkippedWizardValues = (nextStep, wizardActiveStep, wizardItem, wizardSelectedValues) => {
  if (nextStep > wizardActiveStep) {

    const wizardSteps = getAvailableSteps(wizardItem, wizardSelectedValues, true);
    wizardSteps.forEach((step, stepIndex) => {
      if ((stepIndex < nextStep) && !wizardSelectedValues[stepIndex]) {
        const wizardGroup = step.stepGroups[0];
        if (wizardGroup) {
          const skippedValue = {
            [stepIndex]: {
              wizardGroup,
            }
          }
          store.dispatch(setWizardSelectedValues(skippedValue));
          wizardSelectedValues = Object.assign(wizardSelectedValues, skippedValue); // this is needed for code below
        }
      }
    });
  }
  return wizardSelectedValues
}

export const switchToWizardItem = (wizardItem, nextStep, quoteIndex, wizardGroupId = null) => {
  const {quotesState, wizardState} = store.getState();
  const {allWizardsValues, wizardActiveStep} = wizardState;

  if (!wizardItem) {
    wizardItem = getDefaultMaterialsWizardItem();
  }

  let wizardValues = {};
  let foundWizardSelectedObject = null;
  const currentQuoteWizards = allWizardsValues.filter(wizValue => wizValue.quoteIndex === quotesState.activeQuoteIndex);
  if (currentQuoteWizards.length) {
    foundWizardSelectedObject = currentQuoteWizards.find(wizItem => wizItem.wizardItemId === wizardItem.id);
    if (foundWizardSelectedObject) {
      wizardValues = Object.assign({}, foundWizardSelectedObject.wizardSelectedValues);
      wizardValues = getSkippedWizardValues(nextStep, wizardActiveStep, wizardItem, wizardValues);
    }
  }
  store.dispatch(setWizardActiveItem(wizardItem, quoteIndex));
  store.dispatch(setWizardSelectedValues(wizardValues, true, wizardItem));
  if (Number.isInteger(nextStep)) {
    if (wizardGroupId) {
      const {neededStep} = getWizardGroupFromCurrentSteps(wizardItem, wizardValues, wizardGroupId);
      if (neededStep && (neededStep.stepIndex !== nextStep)) {
        nextStep = neededStep.stepIndex
      }
    }
    store.dispatch(setWizardActiveStep(nextStep));
  } else {
    nextStep = foundWizardSelectedObject && Number.isInteger(foundWizardSelectedObject.lastVisitedStep)
      ? foundWizardSelectedObject.lastVisitedStep // restore last step
      : wizardValues ? Object.keys(wizardValues).length : 0 // restore last step (just in case lastVisitedStep is missing)
    if (nextStep === 0 && wizardActiveStep !== 0) {
      store.dispatch(setWizardActiveStep(0)); // cases when someone changes the wizard
    }
  }
  const urlStepNumber = nextStep + 1; // because we don't want to have 0 in the URL
  const nextUrl = "/materials/" + Misc.getUrlFromString(wizardItem.name) + "/" + urlStepNumber;
  const currentHash = window.location.hash.split("#")[1];
  if (!currentHash || (currentHash !== nextUrl)) {
    hashHistory.push(nextUrl);
  }
}

export const useChangeWizardStepRoute = () => {

  let history = useHistory();
  let routeMatch = useRouteMatch();
  // {
  // isExact: true,
  // params: {partName: 'kitchen-cabinets', subPartName: '1'},
  // path: "/materials/:partName/:subPartName",
  // url: "/materials/kitchen-cabinets/3/upper-cabinet-boxes"
  // }
  // let {partName, subPartName} = routeMatch.params;
  let {partName} = routeMatch.params;

  const changeWizardStepRoute = (nextStep, propsWizardItem) => {

    const {wizardActiveItem, wizardActiveStep, wizardList} = store.getState().wizardState;
    let {wizardSelectedValues} = store.getState().wizardState;

    const currentWizardItem = propsWizardItem || wizardActiveItem;

    wizardSelectedValues = getSkippedWizardValues(nextStep, wizardActiveStep, currentWizardItem, wizardSelectedValues);

    const currentGroups = getCurrentGroups(currentWizardItem, nextStep, wizardSelectedValues);

    if (wizardActiveStep > -1 && !currentGroups.length) { // wizard finished! congratulations
      const currentWizardIndex = wizardList.findIndex(wizardItem => wizardItem.id === currentWizardItem.id);

      if (nextStep === -1 && wizardActiveStep === 0) { // go to the previous wizard
        const prevEnabledWizard = wizardList.find((wizardItem, wizardItemIndex) => {
          return (wizardItem.id !== currentWizardItem.id) && (wizardItemIndex < currentWizardIndex)
        });
        if (prevEnabledWizard) {
          switchToWizardItem(prevEnabledWizard);
        } else {
          history.push(ROUTES.quoteDesign);
        }
        return;
      }

      const nextEnabledWizard = wizardList.find((wizardItem, wizardItemIndex) => {
        return (wizardItem.id !== currentWizardItem.id) && (wizardItemIndex > currentWizardIndex)
      });
      if (nextEnabledWizard) {
        switchToWizardItem(nextEnabledWizard);
      } else {
        history.push(ROUTES.shoppingcart);
      }
      return;
    }

    // console.log("nextStep", nextStep);
    store.dispatch(setWizardActiveStep(nextStep));

    if (IS_LIXIL_UI) {
      return; // no need to change url
    }

    // console.log("subPartName", subPartName);
    // console.log("partName", partName);
    // console.log("history", history);

    if (!partName) {
      partName = Misc.getUrlFromString(currentWizardItem.name)
    }

    const wizardGroup = currentGroups[0];
    if (!wizardGroup) {
      console.info("no wizard group found, something is wrong with the wizard", );
      return
    }
    const stepUrl = Misc.getUrlFromString(wizardGroup.customDisplayName || wizardGroup.groupName || "");

    const urlStepNumber = nextStep + 1; // because we don't want to have 0 in the URL
    history.push("/materials/" + partName + "/" + urlStepNumber + (stepUrl ? "/" + stepUrl : ""));
  }

  return {changeWizardStepRoute}
}
